import { Checkbox } from '@neo/primitives/checkbox'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@neo/primitives/table'
import type { CustomField } from 'v2/shared/services/external-apps-service'

interface CustomFieldsTableProps {
  fields: CustomField[]
  onFieldsChange: (fields: CustomField[]) => void
  entity: string
}

export const CustomFieldsTable = ({ fields, onFieldsChange, entity }: CustomFieldsTableProps) => {
  const handleCheckboxChange = (
    fieldId: string,
    permission: 'view' | 'create' | 'edit',
    checked: boolean,
  ) => {
    const updatedFields = fields.map((field) =>
      field.field_identifier === fieldId ? { ...field, [permission]: checked } : field,
    )
    onFieldsChange(updatedFields)
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[50%] text-tertiary">Field name</TableHead>
          <TableHead className="w-[50%] text-tertiary">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {fields.map((field: CustomField) => (
          <TableRow key={field.field_identifier} className="border-b">
            <TableCell>{field.title}</TableCell>
            <TableCell>
              <div className="flex gap-6 items-center">
                <div className="flex items-center gap-2">
                  <Checkbox
                    id={`view-${entity}-${field.field_identifier}`}
                    name={`view-${entity}-${field.field_identifier}`}
                    data-testid={`view-${entity}-${field.field_identifier}`}
                    label="View"
                    onChange={(checked) =>
                      handleCheckboxChange(field.field_identifier, 'view', checked)
                    }
                    value={field.view}
                  />
                </div>
                <div className="flex items-center gap-2">
                  <Checkbox
                    id={`create-${entity}-${field.field_identifier}`}
                    name={`create-${entity}-${field.field_identifier}`}
                    data-testid={`create-${entity}-${field.field_identifier}`}
                    label="Create"
                    onChange={(checked) =>
                      handleCheckboxChange(field.field_identifier, 'create', checked)
                    }
                    value={field.create}
                  />
                </div>
                <div className="flex items-center gap-2">
                  <Checkbox
                    id={`edit-${entity}-${field.field_identifier}`}
                    name={`edit-${entity}-${field.field_identifier}`}
                    data-testid={`edit-${entity}-${field.field_identifier}`}
                    label="Edit"
                    onChange={(checked) =>
                      handleCheckboxChange(field.field_identifier, 'edit', checked)
                    }
                    value={field.edit}
                  />
                </div>
              </div>
            </TableCell>
          </TableRow>
        ))}
        {fields.length === 0 && (
          <TableRow>
            <TableCell colSpan={2} className="h-24 text-center">
              No custom fields found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  )
}
